module.exports = __webpack_public_path__ + "static/media/main-res.71ae7917.jpg";